import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { toast } from 'react-toastify';
import ButtonForm from '../components/ButtonForm';
import GoogleBox from '../components/GoogleBox';

function LogIn() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const { email, password } = formData;
  const navigate = useNavigate();

  const onChange = e => {
    setFormData(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const onSubmit = async e => {
    e.preventDefault();

    try {
      const auth = getAuth();

      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );

      if (userCredential.user) {
        navigate('/my-library');
      }
    } catch (error) {
      toast.error('Bad user credentials');
    }

    setFormData({
      email: '',
      password: '',
    });
  };

  return (
    <form className="form" onSubmit={onSubmit}>
      <div className="form__control u-margin-bottom-m">
        <h4 className="heading-4">Email</h4>

        <input
          type="email"
          name="email"
          id="email"
          className="form__input"
          value={email}
          required
          onChange={onChange}
        />
      </div>

      <div className="form__control u-margin-bottom-xl">
        <h4 className="heading-4">Password</h4>

        <input
          type="password"
          name="password"
          id="password"
          className="form__input"
          value={password}
          required
          onChange={onChange}
        />
      </div>

      <div className="form__control u-margin-bottom-m">
        <ButtonForm />
      </div>

      <GoogleBox />
    </form>
  );
}

export default LogIn;
